import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import { getNetworkName } from '@/utils/network/getNetworkName'
import Fuse from 'fuse.js'

const SEARCH_KEYS = [
  'name',
  'tokenSymbol',
  'assetData.asset.name',
  'protocolName',
  'networkName',
  'market.marketId',
  'collateralAssets.asset.symbol',
  'collateralAssets.asset.name',
] satisfies Fuse.FuseOptionKey<BorrowMarketRow>[]
const FORMATTED_NETWORK_SEARCH_KEY = 'formattedNetwork'

const SEARCH_OPTIONS: Fuse.IFuseOptions<BorrowMarketRow> = {
  ignoreLocation: true,
  threshold: 0.1,
  keys: SEARCH_KEYS,
}

export function searchBorrowMarkets(borrowMarkets: BorrowMarketRow[], searchFor: string) {
  const formattedBorrowMarkets = borrowMarkets.map((borrowMarket) => ({
    ...borrowMarket,
    [FORMATTED_NETWORK_SEARCH_KEY]: getNetworkName(borrowMarket.networkName),
  }))
  const searchTerms = searchFor.split(' ')

  return searchTerms.reduce((searchResults, searchTerm) => {
    if (!searchTerm || searchTerm === ' ') return searchResults
    const fuse = new Fuse(searchResults, {
      ...SEARCH_OPTIONS,
      keys: [...SEARCH_KEYS, FORMATTED_NETWORK_SEARCH_KEY],
    })
    return fuse.search(searchTerm).map((result) => result.item)
  }, formattedBorrowMarkets)
}
